import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconText = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M5 8h2V6h3.252L7.68 18H5v2h8v-2h-2.252L13.32 6H17v2h2V4H5z" }) }));
const Memo = memo(SvgIconText);
export default Memo;
//# sourceMappingURL=IconText.js.map